export const layerStyles = {
  base: {
    bg: 'white',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
};
